export const CUTOFFS = { 
  "47 Claremont": {
    "3-Person Suite": "30 | 2228",
    "4-Person Suite": "30 | 2370",
    "5-Person Suite": "20 | 2224",
    "6-Person Suite": "26.6667 | 2909",
    "7-Person Suite": "10 | 2645"
  },
  "600 West 113": {
    Double: "10 | 2276",
    Single: "30 | 2975",
    "Walk-Through Double": "10 | 2388"
  },
  Broadway: {
    "Interior Single": "11.6667 | 349",
    "Interior Double": "10 | 2231",
    "Large Single": "20 | 2155",
    "Small Double (39/40 lines)": "10 | 2630",
    "Double": "10 | 2189",
    "Large Double": "10 | 2189",
    "Single": "10 | 37"
  },
  "Carlton Arms": {
    "3 Person Suite (1 Sgl/1 Dbl)": "10 | 321",

    "4 Person Suite (2 Sgl/1 Dbl)": "10 | 983",

    "4 Person Suite (2 Dbl)": "10 | 981",

    "5 Person Suite (5 Sgl)": "30 | 2407",

    "5 Person Suite (3 Sgl/1 Dbl)": "20 | 2436",

    "6 Person Suite (2 Sgl/2 Dbl)": "20 | 2502",

    "8 Person Suite (2 Sgl/3 Dbl)": "10 | 393"
  },
  "East Campus": {
    "2-Person Highrise Flat": "30 | 1910",

    "5 Person Highrise Suite (3 Sgl/1 Dbl)": "20 | 548",

    "5 Person Highrise Suite (All Sgl)": "30 | 320",

    "6 Person Highrise Suite (All Sgl)": "30 | 1459",

    "6th Floor Highrise Double": "10 | 1425",

    "2 in 4 Person Townhouse Suite (All Sgl) w/RA": "30 | 2122",

    "4 in 6 Person Townhouse Suite (All Sgl) w/RA": "30 | 1615",

    "4 Person Townhouse Suite (All Sgl)": "30 | 821",

    "6-Person Townhouse Suite (4 Sgl / 1 Dbl)": "30 | 2694",

    "6-Person Townhouse Suite (all singles)": "30 | 2299"
  },
  Furnald: {
    "Double": "FY",

    "Single": "10 | 181"
  },
  Harmony: {
    "Double": "10 | 2712",

    "6 Person Suite (4 Sgl/1 Dbl)": "20 | 2948",

    "Single": "10 | 1841"
  },
  Hogan: {
    "2 in 4 Person Suite w/RA": "30 | 2423",

    "4 in 6 Person Suite w/RA": "30 | 1499",

    "4-Person Suite": "30 | 1292",

    "5-Person Suite": "30 | 1534"
  },
  McBain: {
    "Double": "10 | 2998",

    "Single": "10 | 1385"
  },
  River: {
    "Big Single": "30 | 2137",

    "Single": "20 | 1454"
  },
  Ruggles: {
    "2 in 4-person Suite w/RA": "20 | 816",

    "4-Person Suite": "30 | 2470",

    "6-Person Suite": "21.6667 | 1578",

    "8-Person Suite": "20 | 2990"
  },
  Schapiro: {
    "Double": "10 | 2953",

    "Single": "11.667 | 349",

    "Walk-Through Doubles (05/07 lines)": "10 | 2505"
  },
  Watt: {
    "1-Bedroom Apartment": "20 | 240",

    "2-Bedroom Apartment": "30 | 803",

    "Studio Double": "20 | 2738",

    "Studio Single": "30 | 90"
  },
  Wien: {
    "Double": "10 | 2934",

    "Single": "10 | 2959"
  },
  Woodbridge: {
    "High Demand (H + K + C lines)": "30 | 2012",

    "Medium Demand (all others)": "20 | 110",

    "Low Demand (G + D + I lines)": "20 | 2994"
  }
};

export const SUITE_PICK = new Set(['47 CLAREMONT', 'CARLTON ARMS', 'EAST CAMPUS', 'HARMONY', 'HARTLEY', 'HOGAN', 'RUGGLES']);